import React from 'react';
import Point from '../Point/Point';
import RouteArrow from '../RouteArrow/RouteArrow';
import { getDurationString, getFlightDuration } from '../../../../Results/utils';
import StopsInfo from '../StopsInfo/StopsInfo';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import { format, removeDotsFromDate } from '../../../../utils';
const RouteInfo = ({ segmentWithTransfer, segments, first, last, stops, isCanceled, multipleSegments, stopsSeparator, totalDuration }) => {
    const theme = useTheme('DesktopFlightRoute').RouteInfoStyles;
    const arrowTheme = useTheme('DesktopFlightRoute').RouteArrowStyles;
    const pointTheme = useTheme('DesktopFlightRoute').PointStyles;
    const { segment, transferDuration } = segmentWithTransfer;
    const { arrival, departure } = segment;
    const { arrival: { airport: arrivalAirport }, departure: { airport: departureAirport } } = segment;
    const flightNumber = `${segment.marketingAirline.iata}-${segment.flightNumber}`;
    const stopsCount = stops === null || stops === void 0 ? void 0 : stops.length;
    const hasStops = !!stopsCount;
    const departureDate = 'date' in departure && departure.date ? removeDotsFromDate(format(departure.date, 'dd MMM, EEEEEE')) : '';
    const arrivalDate = 'date' in arrival && arrival.date ? removeDotsFromDate(format(arrival.date, 'dd MMM, EEEEEE')) : '';
    const timeInRoute = (segments === null || segments === void 0 ? void 0 : segments.length) > 1 ? getDurationString(getFlightDuration(segments)) : getDurationString(segment.duration);
    return (React.createElement("div", { className: theme.route__info },
        React.createElement("div", { className: theme.row },
            React.createElement(Point, { time: segment.departure.time, thin: !first, date: departureDate }),
            React.createElement(RouteArrow, { timeInRoute: timeInRoute, className: theme.arrow_container }),
            React.createElement(Point, { time: segment.arrival.time, thin: !last, arrival: true, date: arrivalDate })),
        React.createElement("div", { className: theme.row },
            React.createElement("div", { className: pointTheme.airport },
                departureAirport.name,
                " (",
                departureAirport.iata,
                ")"),
            flightNumber && React.createElement("div", { className: arrowTheme.flightNumber }, flightNumber),
            React.createElement("div", { className: cn(pointTheme.airport, pointTheme.airport_arrival) },
                arrivalAirport.name,
                " (",
                arrivalAirport.iata,
                ")"),
            (transferDuration || hasStops) && !isCanceled && (React.createElement(StopsInfo, { stops: stops, stopCityName: arrivalAirport.name, transferDuration: transferDuration, separator: stopsSeparator }))),
        totalDuration && multipleSegments && !isCanceled && (React.createElement("div", { className: theme.totalDuration },
            React.createElement("span", null, totalDuration)))));
};
export default RouteInfo;
